// export default () => ({
// })

export default () => ({
    staffers: [],
    staffersSelectable: [],
    staffersPaginatedData: null,
    staffer: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})